<div flex class="h-screen w-screen flex flex-col">
    <app-navbar></app-navbar>
    <div class="h-full">
        <router-outlet></router-outlet>
    </div>
</div>